module.exports = __webpack_public_path__ + "static/media/logo.cff23e83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GlobalNav/assets/logo.svg
// module id = 1925
// module chunks = 0